<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("view") }} {{ $t("customization") }}
      </div>
      <div>
        <a
          class="btn-blue"
          href
          @click.prevent.stop="goToRoute('/fnb/edit-customization', fnb_item)"
          >{{ $t("edit") }} {{ $t("customization") }}</a
        >
        <router-link class="btn-blue" to="/fnb/customization"
          >{{ $t("customization") }} {{ $tc("list", 2) }}</router-link
        >
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("customizationName") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ recipe_label }}</div>
            </div>
          </div>

          <!-- item_code -->
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("item_code", 1) }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ fnb_item.item_code }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("recipe", 1) }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ fnb_item.recipe_name }}
              </div>
            </div>
          </div>
          <!-- includes_egg -->
          <!-- <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('includesegg', 1) }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{fnb_item.includes_egg}}</div>
            </div>
          </div>-->

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("foodcategory") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ fc_parent_label }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("isSundry") }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ fnb_item.is_sundry == "Y" ? $t("Yes") : $t("No") }}
              </div>
            </div>
          </div>

          <!-- <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('itemcostprice') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{itemcost_price.costprice}}</div>
            </div>
          </div>-->

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("image") }}</div>
              <img
                v-lazy="URL_BASE + fnb_item.item_image_url"
                width="100"
                height="100"
              />
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("active", 1) }}
              </div>
              <div
                v-if="fnb_item.item_is_active"
                class="col-md-9 col-lg-10 col-xl-10"
              >
                {{ $t("Yes") }}
              </div>
              <div v-else class="col-md-9 col-lg-10 col-xl-10">
                {{ $t("No") }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("isveg", 1) }}
              </div>
              <div
                v-if="fnb_item.item_is_veg"
                class="col-md-9 col-lg-10 col-xl-10"
              >
                {{ $t("Yes") }}
              </div>
              <div v-else class="col-md-9 col-lg-10 col-xl-10">
                {{ $t("No") }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("includesegg", 1) }}
              </div>
              <div
                v-if="fnb_item.includes_egg"
                class="col-md-9 col-lg-10 col-xl-10"
              >
                {{ $t("Yes") }}
              </div>
              <div v-else class="col-md-9 col-lg-10 col-xl-10">
                {{ $t("No") }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ "Alternate FNB Items" }}
              </div>
              <div
                v-if="
                  selected_alternate_items &&
                    selected_alternate_items.length > 0
                "
                class="col-md-9 col-lg-10 col-xl-10"
              >
                <div
                  v-for="(item, itemIndex) in selected_alternate_items"
                  :key="itemIndex"
                >
                  {{ item.item_name }}
                </div>
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10" v-else>-</div>
            </div>
          </div>

          <table class="table table-striped">
            <thead>
              <tr>
                <th>{{ $t("cinema") }}</th>
                <th>{{ $t("itemcostprice") }}</th>
                <th>{{ $tc("chargesettingname", 1) }}</th>
                <th>{{ $tc("netAmount", 1) }}</th>
                <th>{{ $tc("grossAmount", 1) }}</th>
                <th>{{ $tc("fromdate", 1) }}</th>
                <th>{{ $tc("todate", 1) }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(singleCinema, CinemaIndex) in CinemaPriceSettings"
                :key="CinemaIndex"
              >
                <td>{{ singleCinema.selectedCinema }}</td>
                <td>{{ singleCinema.itemcost_price.costprice }}</td>
                <td>{{ singleCinema.ratecard.frc_pas_setting_name }}</td>
                <td>{{ singleCinema.ratecard.frc_net_amount }}</td>
                <td>{{ singleCinema.ratecard.frc_amount }}</td>
                <td>
                  {{ singleCinema.ms_fnb_price.fp_from_date | dateparse }}
                </td>
                <td>{{ singleCinema.ms_fnb_price.fp_to_date | dateparse }}</td>
              </tr>
            </tbody>
          </table>

          <!-- <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('chargesetting') }}</div>
              <div
                class="col-md-9 col-lg-10 col-xl-10"
              >{{ cinemaChargesList.length === 0 ? '' : cinemaChargesList[0].pas_charge_setting_name}}</div>
            </div>
          </div>-->

          <!-- new -->
          <!-- <div
            class="col-md-12 py-2 border-bottom"
            v-for="(cinemaCharge, cinemaChargesListIndex) in list"
            :key="cinemaChargesListIndex"
          >
            <div class="row">
              <div class="col-md-2">
                <label>{{ cinemaCharge.ct_name }}</label>
              </div>
              <div class="col-md-3">
                <label>{{ cinemaCharge.pas_charge_value }}{{ cinemaCharge.pas_is_percentage == 'Y' ? '%': ''}}</label>
              </div>

              <div class="col-md-7">
                <label>{{ cinemaCharge.frcs_amount.toFixed(4) }}</label>
              </div>
            </div>
          </div>-->

          <!-- <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('netAmount') }}</div>
              <div
                class="col-md-9 col-lg-10 col-xl-10"
              >{{ ms_fnb_price['fp_amount'] ? ms_fnb_price.fp_amount.toFixed(2): ""}}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('grossAmount') }}</div>
              <div
                class="col-md-9 col-lg-10 col-xl-10"
              >{{ ms_fnb_price['fp_total_amount'] ? ms_fnb_price.fp_total_amount.toFixed(2): ""}}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('fromdate') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ms_fnb_price.fp_from_date | dateparse}}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('todate') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ms_fnb_price.fp_to_date | dateparse}}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('inclusivoftax') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{tax}}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('daysactive') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{weeksKeynName}}</div>
            </div>
          </div>-->

          <div class="col-12" v-if="GetRoleId && GetRoleId === 1">
            <div class="row">
              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">
                    {{ $t("createdby") }}
                  </div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span>{{ created_by }}</span>
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">
                    {{ $t("createdat") }}
                  </div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span class="mr-3">{{
                      fnb_item.created_at | dateparse
                    }}</span>
                    <!-- <span>12:05 AM</span> -->
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">
                    {{ $t("modifiedby") }}
                  </div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span>{{ updated_by }}</span>
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">
                    {{ $t("modifiedat") }}
                  </div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span class="mr-3">{{
                      fnb_item.updated_at | dateparse
                    }}</span>
                    <!-- <span>12:05 AM</span> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import { BASEURL } from "@/config/index.js";
import PosFnbService from "@/services/PosFnbService";

export default {
  data() {
    return {
      selected_alternate_items: [],
      fnb_item: {
        item_id: "",
        item_code: "",
        fc_id: "",
        recipe_id: "",
        is_sundry: "N",
        item_is_veg: true,
        includes_egg: true,
        item_is_recipe: "",
        item_image_url: ""
      },
      URL_BASE: BASEURL,
      customization_name: "",
      created_by: "",
      updated_by: "",
      ms_food_categories: [],
      BaseURL: "",
      recipes: [],
      recipe_label: "",
      fc_parent_label: "",
      cinemaList: [],
      CinemaPriceSettings: [
        {
          selectedCinema: "",
          cinema_id: null,
          recipe_label: "",
          //ITEM COST PRICE
          itemcost_price: {
            itc_id: "",
            cinema_id: "",
            v_id: "",
            item_id: "",
            costprice: "",
            fp_is_active: true
          },
          //RATE CARD
          isRoleID: true,
          selectedCinema: "",
          cinemaList: [],
          currencyData: [],
          ratecard: {
            frc_id: null,
            cinema_id: null,
            frc_name: Math.floor(1000 + Math.random() * 9000),
            frc_amount: 0,
            currency_id: null,
            frc_is_active_inclusivtax: "Y",
            frc_is_active: "N",
            frc_net_amount: 0,
            frc_total_amount: 0,
            curr_code: null
          },
          selectedChargeSettingName: "",
          pas_setting_name_list: [],
          cinemaChargesList: [],
          //FNB Pricing
          weekDays: {
            selectAll: false,
            sunday: false,
            monday: false,
            tuesday: false,
            wednesday: false,
            thursday: false,
            friday: false,
            saturday: false
          },
          ms_fnb_price: {
            cinema_id: "",
            item_id: "",
            currency_id: "",
            fnb_rate_card_id: "",
            fp_amount: "",
            fp_total_amount: "",
            fp_from_date: "",
            fp_to_date: "",
            fp_is_active: true,
            fp_sunday: true,
            fp_monday: true,
            fp_tuesday: true,
            fp_wednesday: true,
            fp_thursday: true,
            fp_friday: true,
            fp_saturday: true
          }
        }
      ]
    };
  },
  computed: {
    weeksKeynName() {
      return Object.keys(this.weekDays)
        .filter(x => x !== "selectAll" && this.weekDays[x])
        .map(x => x)
        .join(", ");
      // return null
    },
    tax() {
      if (this.ratecard.frc_is_active_inclusivtax == "Y") {
        return "Yes";
      } else {
        return "No";
      }
    },
    list() {
      return this.cinemaChargesList;
    }
  },
  beforeMount() {
    this.fnb_item.item_code = this.$route.query.item_code;
    this.getCinemaList();
  },
  async mounted() {
    this.getFnbItemDetails();
    this.getAssignedAlternateItems();
    // this.getItemCostPrice();
    // this.getFnbPricing();
  },
  methods: {
    getAssignedAlternateItems: function() {
      PosFnbService.GetAssignedAlternateItems({
        item_code: this.fnb_item.item_code
      })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.selected_alternate_items = data.Records;
          } else {
          }
        })
        .catch(error => {
          console.log("Catch Error on getAssignedAlternateItems :", error);
        });
    },
    getCinemaList: function(cinema_id) {
      let body = this.getRequestBody("GET", undefined, {
        GET: "/admin/",
        tableName: "ms_cinemas"
      });
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.cinemaList = data.Records;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getFnbItemDetails: function() {
      PosFnbService.GetFnbItem({ item_code: this.fnb_item.item_code })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            for (var i = 0; i < data.Records.length - 1; i++) {
              this.addCinemaSetting();
            }

            data.Records.map((x, index) => {
              this.CinemaPriceSettings[index]["item_id"] = x.item_id;
              this.CinemaPriceSettings[index].itemcost_price.item_id =
                x.recipe_id;
              this.getItemCostPrice(x.item_id, index);
            });

            this.fnb_item = data.Records[0];
            this.customization_name = data.Records[0].customization_name;
            this.fnb_item.is_sundry = data.Records[0].is_sundry || "N";
            this.fnb_item.item_is_veg =
              this.fnb_item.item_is_veg == "Y" ? true : false;
            this.fnb_item.includes_egg =
              this.fnb_item.includes_egg == "Y" ? true : false;
            this.recipe_label = this.fnb_item.item_name;

            this.fc_parent_label = this.fnb_item.fc_category;
            Object.keys(this.fnb_item).map(x => {
              if (x === "created_by") {
                this.getViewUsersDetails(this.fnb_item[x], "created_by");
              } else if (x === "updated_by") {
                this.getViewUsersDetails(this.fnb_item[x], "updated_by");
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getCinemaName(cinema_id, index) {
      this.cinemaList.map(x => {
        if (String(cinema_id) == String(x.cine_id)) {
          this.CinemaPriceSettings[index].selectedCinema = x.cine_name;
        }
      });
    },
    addCinemaSetting: function(item, index) {
      this.getGlobalOptions();
      this.CinemaPriceSettings.push({
        selectedCinema: "",
        cinema_id: null,
        recipe_label: "",
        //ITEM COST PRICE
        itemcost_price: {
          itc_id: "",
          cinema_id: "",
          v_id: "",
          item_id: "",
          costprice: "",
          fp_is_active: true
        },
        //RATE CARD
        isRoleID: true,
        selectedCinema: "",
        cinemaList: [],
        currencyData: [],
        ratecard: {
          frc_id: null,
          cinema_id: null,
          frc_name: Math.floor(1000 + Math.random() * 9000),
          frc_amount: 0,
          currency_id: null,
          frc_is_active_inclusivtax: "Y",
          frc_is_active: "N",
          frc_net_amount: 0,
          frc_total_amount: 0,
          curr_code: null
        },
        selectedChargeSettingName: "",
        pas_setting_name_list: [],
        cinemaChargesList: [],
        //FNB Pricing
        weekDays: {
          selectAll: false,
          sunday: false,
          monday: false,
          tuesday: false,
          wednesday: false,
          thursday: false,
          friday: false,
          saturday: false
        },
        ms_fnb_price: {
          fp_id: "",
          cinema_id: "",
          item_id: "",
          currency_id: "",
          fp_id: "",
          fnb_rate_card_id: "",
          fp_amount: "",
          fp_total_amount: "",
          fp_from_date: "",
          fp_to_date: "",
          fp_is_active: true,
          fp_sunday: true,
          fp_monday: true,
          fp_tuesday: true,
          fp_wednesday: true,
          fp_thursday: true,
          fp_friday: true,
          fp_saturday: true
        }
      });
    },
    getItemCostPrice: function(item_id, index) {
      let payload = {
        tableName: "item_cost_price",
        itc_is_active: "Y",
        item_id: item_id
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            // for (var i = 0; i < data.Records.length - 1; i++) {
            //   this.addCinemaSetting();
            // }

            data.Records.map(obj => {
              this.getCinemaName(obj.cinema_id, index);
              this.CinemaPriceSettings[index].cinema_id = obj.cinema_id;
              this.CinemaPriceSettings[index].recipe_label =
                this.CinemaPriceSettings[index].itemcost_price.item_id &&
                String(this.CinemaPriceSettings[index].itemcost_price.item_id)
                  .length > 0
                  ? this.recipe_label
                  : "";
              this.CinemaPriceSettings[index].itemcost_price.cinema_id =
                obj.cinema_id;
              this.CinemaPriceSettings[index].itemcost_price.itc_id =
                obj.itc_id;
              this.CinemaPriceSettings[index].itemcost_price.costprice =
                obj.itc_cost_price;
              this.CinemaPriceSettings[index].itemcost_price.fp_is_active =
                obj.itc_is_active;
            });
            this.getFnbPricing(item_id, index);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    getFnbPricing: function(item_id, index) {
      let payload = {
        tableName: "ms_fnb_price",
        fp_is_active: "Y",
        item_id: item_id
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            // this.recipes = data.Records;
            // console.log("ITC", data.Records);
            // let obj = data.Records[0];
            data.Records.map(obj => {
              // this.ms_fnb_price = obj;
              this.setDaysValue(obj, index);
              this.CinemaPriceSettings[index].ms_fnb_price.item_id = item_id;
              this.CinemaPriceSettings[index].ms_fnb_price.fp_id = obj.fp_id;
              this.CinemaPriceSettings[index].ms_fnb_price.cinema_id =
                obj.cinema_id;
              this.CinemaPriceSettings[index].ms_fnb_price.fnb_rate_card_id =
                obj.fnb_rate_card_id;
              this.CinemaPriceSettings[
                index
              ].ms_fnb_price.fp_from_date = new Date(obj.fp_from_date);
              this.CinemaPriceSettings[index].ms_fnb_price.fp_to_date =
                obj.fp_to_date && isValidDate(new Date(obj.fp_to_date))
                  ? new Date(obj.fp_to_date)
                  : new Date();
              this.getEditRatecardList(obj.fnb_rate_card_id, index);
            });
            function isValidDate(d) {
              if (Object.prototype.toString.call(d) === "[object Date]") {
                // it is a date
                if (isNaN(d.getTime())) {
                  return false;
                  // d.valueOf() could also work
                  // date is not valid
                } else {
                  return true;
                  // date is valid
                }
              } else {
                return false;
                // not a date
              }
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    getViewUsersDetails(user_id, fieldvalue) {
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this[fieldvalue] = data.Records[0].user_name;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      }
    },
    getGlobalOptions: function() {
      MasterService.GetGlobalOptions()
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            data.Records.map(x => {
              if (x.go_key === "CURRENCY") {
                this.CinemaPriceSettings.map((y, index) => {
                  this.CinemaPriceSettings[index].ratecard.currency_id =
                    x.go_value || null;
                  this.CinemaPriceSettings[index].ms_fnb_price.currency_id =
                    x.go_value || null;
                });
              }
            });
          } else {
            // Show Error
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          //Catch Error
          console.log("catch error on GetGlobalOptions :", error);
        });
    },
    setDaysValue: function(voucherDays, index) {
      let days = {
        sunday: "fp_sunday",
        monday: "fp_monday",
        tuesday: "fp_tuesday",
        wednesday: "fp_wednesday",
        thursday: "fp_thursday",
        friday: "fp_friday",
        saturday: "fp_saturday"
      };
      if (voucherDays) {
        Object.keys(days).map(x => {
          this.CinemaPriceSettings[index].weekDays[x] =
            voucherDays[days[x]] === "Y" ? true : false;
        });

        let array = Object.keys(
          this.CinemaPriceSettings[index].weekDays
        ).filter(
          x => x !== "selectAll" && !this.CinemaPriceSettings[index].weekDays[x]
        );
        if (array.length === 0) {
          this.CinemaPriceSettings[index].weekDays["selectAll"] = true;
        }
      }
    },
    goToRoute: function(path, { item_code }) {
      this.$router.push({
        path: path,
        query: {
          item_code: item_code
        }
      });
    },
    getEditRatecardList: function(id, index) {
      PosFnbService.GetRatecardById({ id })
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.CinemaPriceSettings[index].ratecard = {
                ...this.CinemaPriceSettings[index].ratecard,
                ...data.Records[0]
              };
              // this.getCinemaList(data.Records[0].cinema_id);
              // this.ratecard.currency_id = data.Records[0].curr_id;
              this.CinemaPriceSettings[index].cinemaChargesList =
                data.Records[0].chargesList || [];
              // this.cinemaChargesCalculation(index);
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/customizationComponents/viewCustomization.vue